// extracted by mini-css-extract-plugin
export default {"spanRight":"SelfManagementPlanCareComponent_spanRight__krPCZ"};